import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraId: number
  onError?: (error: unknown) => void
  enabled?: boolean
  start: number
  end?: number
  listSize?: number
}

export default function useStartStreamWithTimestamp({cameraId, onError, enabled = true, start, end, listSize}: Props) {
  const query = useQuery({
    enabled,
    retry: 0,
    queryKey: [QueryKeyEnum.START_STREAM, cameraId, end, start, listSize],
    queryFn: async () => {
      return api.streaming.startStreamWithTimestamp(cameraId, start, end, listSize)
    },
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
